const base = '';

module.exports = {
  baseUrl: base,
  apiUrl: `${base}/api/v1`,
};



// WEBPACK FOOTER //
// ./src/details.js